<template>
  <div v-if="!model.$disabled" class="form-group-s" style="position: relative">
    <w-label
      :model="model"
      :title="title"
      :show-label="showLabel"
      :description="description"
      :next-number="nextNumber"
      :bold-label="boldLabel"
      :labelFor="setId"
      :only-description="onlyDescription"
      :autotext="autotext"
    >
      <template v-slot:prepend>
        <slot name="prependlabel" />
      </template>

      <template v-slot:description>
        <slot name="description" />
      </template>

      <template v-slot:append>
        <slot name="appendlabel" />
      </template>
    </w-label>

    <div class="textarea" :class="{'state-error': model.$error, 'state-disabled': isDisabled}">
      <i v-if="prependicon" class="icon-prepend fa" :class="prependicon.startsWith('fa-') ? prependicon : ''" aria-hidden="true">{{
        prependicon.startsWith('fa-') ? '' : prependicon
      }}</i>

      <textarea
        :id="setId"
        ref="input"
        style="overflow: hidden; min-height: 34px"
        :disabled="isDisabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        :class="classObject"
        :placeholder="placeholder"
        :rows="rows"
        :name="model.$form.testPath ? model.$path : undefined"
        :aria-invalid="isError"
        :aria-label="activeAria"
        :aria-describedby="isError ? dataIds.errId : undefined"
        :aria-labelledby="checkLabelledby({maxLength: {lengthId, isMaxLength}, labelledbyId})"
        @input="onInput($event)"
        @blur="onTextareaBlur($event)"
        @focus="onTextareaFocus($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
      />

      <textarea v-if="useHelper" ref="hresize" class="form-control areahelper" style="overflow: hidden" tabindex="-1" />

      <i class="icon-append fa" v-if="appendicon" :class="appendicon.startsWith('fa-') ? appendicon : ''" aria-hidden="true">{{
        appendicon.startsWith('fa-') ? '' : appendicon
      }}</i>
    </div>

    <div v-if="isMaxLength" class="text-note text-muted">
      <small :class="{'text-danger': length > model.$schema.maxLength}" :id="lengthId">{{ length }} z {{ model.$schema.maxLength || 0 }}</small>
    </div>

    <w-error :model="model" @focus="$refs.input.focus()" :id="dataIds.errId" />
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: tooltipVisibility}"

import titleMixin from '../mixins/titleMixin';
import modelMixin from '../mixins/modelMixin';

import WError from './error.vue';
import WTooltip from './tooltip.vue';
import WLabel from './label.vue';

export default {
  name: 'w-textarea',
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    rows: [Number, String],
    nextNumber: {
      type: Object,
      default: null,
      // default: () => ({
      //   level: null,
      //   value: null,
      //   type: null
      // }),
      required: false
    }
  },
  mixins: [modelMixin, titleMixin],
  components: {WError, WTooltip, WLabel},
  data() {
    return {
      length: 0,
      useHelper: false
    };
  },
  mounted() {
    // czy ma sie robic resize przy zmianiae modelu ?
    // console.log('textarea mounted', this.$refs);
    if (true) {
      // console.log('monted $refs', Object.keys(this.$refs));
      this.$watch('svalue', {
        immediate: true,
        handler(newValue) {
          // console.log('$watch textarea', this.$refs);
          this.resize(newValue);
        }
      });
    } else {
      // czy ma się robić resize od razu po podłączeniu
      if (true) {
        this.resize();
      } else if (this.svalue) {
        this.length = this.svalue.length;
      } else {
        this.length = 0;
      }
    }
    // this.resize();
  },
  computed: {
    classObject() {
      const result = ['form-control'];
      if (this.borderless) {
        result.push('borderless');
        if (this.useHelper) {
          result.push('active');
        }
      }

      return result;
    }
  },
  methods: {
    resize(newValue, blur) {
      // console.log('newValue: ', newValue);
      // console.log('$refs', Object.keys(this.$refs));

      if (newValue === undefined) {
        if (this.svalue === undefined) {
          newValue = '';
        } else {
          newValue = this.svalue;
        }
      }

      // let prevheight = this.$options.prevHeight || this.$refs.input.offsetHeight;
      this.length = (newValue || '').length || 0;

      let newHeight = 0;
      if (this.useHelper) {
        if (this.$refs.hresize === undefined) {
          return;
        }
        if (blur) {
          // trzeba zrobić jako opcję
          /*
                this.$refs.input.style.height = "auto";
                this.$refs.input.style.overflow = "auto";
                */
          return;
        }
        this.$refs.hresize.value = newValue + 'aaa';
        // console.log('hresize.value: ', newValue, this.$refs.hresize.value);
        const height = this.$refs.hresize.scrollHeight;
        newHeight = height + 2;
        // console.log('helper textHeight', newHeight);
      } else {
        if (this.$refs.input === undefined) {
          return;
        }
        newHeight = this.$refs.input.scrollHeight + 2;
        // console.log('my textHeight', newHeight);
      }
      // if (newHeight!=height) {
      // console.log('height: ',prevheight,height);
      // console.log('height: ', height);
      //  this.$options.prevHeight=newHeight;
      this.$refs.input.style.overflow = 'hidden';
      this.$refs.input.style.height = newHeight + 'px';
      // }
    },
    onTextareaFocus(evt) {
      // this.model.$hasFocus = true;
      // console.log('localfocus', this.model.$hasFocus);
      this.useHelper = true;
      this.onFocus(evt);
      // eturn true;
      // this.$emit('focus', evt);
    },
    onTextareaBlur(evt) {
      this.useHelper = false;
      // this.resize();
      this.onBlur(evt);
    }
  }
};
</script>

<style>
textarea.areahelper {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
textarea.active {
  background-color: lightyellow !important;
}
</style>
